// extracted by mini-css-extract-plugin
export default {"ratingText":"RatingDisplay-ratingText-e2caa95ca951e52d7790c00f067a5a61"};